import { useState } from "react";
import { Card, Button } from "antd";
import CdekModal from "./CdekModal";

const { Meta } = Card;

export default function IntegrationCdek({ query, websocket }) {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Card
        style={{ width: 250 }}
        cover={
          <div
            style={{
              display: "flex",
              height: 250,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#02354d",
              color: "white",
            }}
          >
             <img
                alt="cdek"
                src="https://upload.wikimedia.org/wikipedia/commons/f/f8/CDEK_logo.svg"  
                style={{ padding: 20 }}
            />
          </div>
        }
        actions={[
          <Button key="setup" onClick={() => setModalVisible(true)}>
            Установить виджет
          </Button>,
        ]}
      >
        <Meta title="СДЭК"/>
      </Card>
      <CdekModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        query={query}
        websocket={websocket}
      />
    </>
  );
}